export default defineNuxtRouteMiddleware(() => {
    const auth = useAuthStore();
    if (!auth.isLogged) return;

    if (auth.isAdmin) return;

    if (auth.isSeller) {
        return navigateTo("/tat/vendedor/Ruta");
    }

    if (auth.isPicker) {
        return navigateTo("/tat/picker/Pedidos");
    }

    if (auth.isCourier) {
        return navigateTo("/tat/transportista/Pedidos");
    }

    return navigateTo("/");
});
